import type { ProjectType } from '@jira/platform__project-types/src/project-types.tsx';
import { getBaseAutomationUrl } from '@atlassian/jira-automation-menu/src/common/utils.tsx';

type ProjectKey = string;

export const buildNewRuleAutomationUrl = (projectProps: {
	projectKey: ProjectKey;
	projectType: ProjectType;
	isSimplified: boolean;
}) =>
	`${getBaseAutomationUrl(
		projectProps,
	)}#rule/new?componentFilterCriteria=RELEASE_MANAGEMENT_TRIGGERS`;

export const buildManageRulesAutomationUrl = (projectProps: {
	projectKey: ProjectKey;
	projectType: ProjectType;
	isSimplified: boolean;
}) => `${getBaseAutomationUrl(projectProps)}#/rule-list`;

export const buildAuditLogAutomationUrl = (projectProps: {
	projectKey: ProjectKey;
	projectType: ProjectType;
	isSimplified: boolean;
}) => `${getBaseAutomationUrl(projectProps)}#tab/audit-log`;

export const buildDiscoverAutomationUrl = (projectProps: {
	projectKey: ProjectKey;
	projectType: ProjectType;
	isSimplified: boolean;
}) => `${getBaseAutomationUrl(projectProps)}#/tab/rule-library`;

export const buildTemplateRuleAutomationUrl = (
	projectProps: {
		projectKey: ProjectKey;
		projectType: ProjectType;
		isSimplified: boolean;
	},
	templateId: string,
) => `${getBaseAutomationUrl(projectProps)}#/rule/template?templateId=${templateId}`;
